<template>
  <div id="Footer">
    <!-- footer-left -->
    <a-Row style="width:100%">
      <a-Col class="footer-l" :xs="24" :sm="12" :md="12" :lg="12">
        <p class="footer-fun">
          <span>
            <router-link to="/about">关于我们</router-link>
          </span>
          <a-divider type="vertical"/>
          <span>
            <router-link to="/agreement">用户协议</router-link>
          </span>
          <a-divider type="vertical"/>
          <span>
            <router-link to="/custody">家长监护工程</router-link>
          </span>
          <a-divider type="vertical"/>
          <span>
            <router-link to="/dispute">交易纠纷处理</router-link>
          </span>
          <a-divider type="vertical"/>
          <span>
            <router-link to="/backIndulge">防沉迷系统</router-link>
          </span>
          <a-divider type="vertical"/>
          <span>
            <router-link to="/news">新闻更新</router-link>
          </span>
        </p>
        <p>
          抵制不良游戏,拒绝盗版游戏,注意自我保护,谨防受骗上当
          <br>适度游戏益脑,沉迷游戏伤身,合理安排时间,享受健康生活
        </p>
        <p>客服电话：021-34971233 客服邮箱地址：service@racoonDigi.com</p>
        <p>地址：上海市闵行区东川路555号乙楼2108（集）B103室</p>
        <p>©上海瑞酷数码科技有限公司版权所有</p>
      </a-Col>
      <a-Col class="footer-r" :xs="24" :sm="12" :md="12" :lg="12">
        <p>更多游戏</p>
        <p>
          <span @click="jqdj()">街球對決</span>
          <br>
          <span @click="jqys()">街球艺术:3对3</span>  
        </p>
        <p>&nbsp;</p>
        <p> 
          <a href="https://beian.miit.gov.cn/" target="_blank"> 沪ICP备14048124号-2</a>
          <img :src="wenhuajingying" alt="文"> 
          <a href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/3C193EB0E0074B99E0530140A8C084A6" target="_blank"> 沪网文〔2016〕4224-313号</a> 
          <img :src="ghs" alt="ghs">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202007179" target="_blank"> 沪公网安备 31011202007179号</a>  
        </p>
      </a-Col>
    </a-Row>
  </div>
</template>
<script>
import { Divider, Row, Col } from "ant-design-vue";
export default {
  name: "Footer",
  data() {
    return {
      ghs: require("@/assets/ghs.png"),
      wenhuajingying: require("@/assets/wenhuajingying.png")
    };
  },
  methods: {
    // 对决
    jqdj(){
      window.open("https://jqdj.9rt.com/")
    },
    // 艺术
    jqys(){
      window.open("http://jqys.tmgigame.com/")
    }
  },
  components: {
    aDivider: Divider,
    aRow: Row,
    aCol: Col
  }
};
</script>
<style lang="stylus" scoped>
@import './common.styl';

#Footer {
  width: 100%;
  background: #232323;
  color: #ccc;
  flex-around();
  padding: 40px; 
  div {
    text-align: center;
  }

  .footer-fun {
    span {
      cursor: pointer;

      a {
        color: #ccc !important;
      }
    }

    span:hover {
      color: #fff;
    }
  }

  .footer-r {
    span {
      cursor: pointer;
    }

    span:hover {
      color: #fff;
    }
    a{
      color:#ccc;
    }
    a:hover{
      color:#fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Footer.vue